import Taskbar from '../components/Taskbar';
import AnimatedSection from '../components/AnimatedSection';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";
 

const IProphecy = () => {
  const images = [
    "/images/Iprophecy/Iprophecy1.jpg",
    "/images/Iprophecy/Iprophecy2.jpg",
    "/images/Iprophecy/Iprophecy3.jpg"
  ];
  const captions = [" ", " ", " "];

  return (
    <>
        <Taskbar />
        <TwoColumnLayout sidebar={<AppSidebar />}>
         <div className="max-[942px]:pt-8 min-[942px]:mt-[51px] bg-bg text-text transition-colors duration-500">
          <AnimatedSection images={images} captions={captions} title="I Prophecy" />
          <h2 className='text-3xl font-bold text-text text-center mt-40 mb-10'>Coming Soon...</h2>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default IProphecy;
